export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/NG-162d3246e31513549c1d5bcd367db8f7.png";